import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Footer.css';
import logoWhite from '../assets/images/metamindlogowhite.svg';

function Footer() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section footer-logo-section">
          <img src={logoWhite} alt="EthosMind Logo" className="footer-logo" />
          <h2 className="footer-title">EthosMind</h2>
          <p className="footer-description">Connecting you with the greatest thinkers in history.</p>
        </div>
        <div className="footer-section">
          <h3 className="footer-subtitle">Explore</h3>
          <ul className="footer-links">
            <li><button onClick={() => handleNavigation('/')}>Home</button></li>
            <li><button onClick={() => handleNavigation('/saintschat')}>PhiloChat</button></li>
            <li><button onClick={() => handleNavigation('/buddhachats')}>BuddhaChat</button></li>
            <li><button onClick={() => handleNavigation('/biblechats')}>BibleChat</button></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3 className="footer-subtitle">Company</h3>
          <ul className="footer-links">
            <li><button onClick={() => handleNavigation('/about')}>About Us</button></li>
            <li><button onClick={() => handleNavigation('/contact')}>Contact</button></li>
            <li><button onClick={() => handleNavigation('/privacy')}>Privacy Policy</button></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3 className="footer-subtitle">Follow Us</h3>
          <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 EthosMind. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
